export function getCookie(cname: any) {
	var name = cname + '=';
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

export function isEmpty(obj) {
	for (var key in obj) {
		if (obj.hasOwnProperty(key))
			return true;
	}
	return false;
}

export function mapOptions() {
	return  {
		styles: [
			{
				'featureType': 'all',
				'elementType': 'geometry.fill',
				'stylers': [
					{
						'weight': '2.00'
					}
				]
			},
			{
				'featureType': 'all',
				'elementType': 'geometry.stroke',
				'stylers': [
					{
						'color': '#ebe7c8'
					}
				]
			},
			{
				'featureType': 'all',
				'elementType': 'labels.text',
				'stylers': [
					{
						'visibility': 'on'
					}
				]
			},
			{
				'featureType': 'landscape',
				'elementType': 'all',
				'stylers': [
					{
						'color': '#ebe7c8'
					}
				]
			},
			{
				'featureType': 'landscape',
				'elementType': 'geometry.fill',
				'stylers': [
					{
						'color': '#ebe7c8'
					}
				]
			},
			{
				'featureType': 'landscape.man_made',
				'elementType': 'geometry.fill',
				'stylers': [
					{
						'color': '#ebe7c8'
					}
				]
			},
			{
				'featureType': 'poi',
				'elementType': 'all',
				'stylers': [
					{
						'visibility': 'off'
					}
				]
			},
			{
				'featureType': 'road',
				'elementType': 'all',
				'stylers': [
					{
						'saturation': -100
					},
					{
						'lightness': 45
					}
				]
			},
			{
				'featureType': 'road',
				'elementType': 'geometry.fill',
				'stylers': [
					{
						'color': '#eeeeee'
					}
				]
			},
			{
				'featureType': 'road',
				'elementType': 'labels.text.fill',
				'stylers': [
					{
						'color': '#7b7b7b'
					}
				]
			},
			{
				'featureType': 'road',
				'elementType': 'labels.text.stroke',
				'stylers': [
					{
						'color': '#ffffff'
					}
				]
			},
			{
				'featureType': 'road.highway',
				'elementType': 'all',
				'stylers': [
					{
						'visibility': 'simplified'
					}
				]
			},
			{
				'featureType': 'road.arterial',
				'elementType': 'labels.icon',
				'stylers': [
					{
						'visibility': 'off'
					}
				]
			},
			{
				'featureType': 'transit',
				'elementType': 'all',
				'stylers': [
					{
						'visibility': 'off'
					}
				]
			},
			{
				'featureType': 'water',
				'elementType': 'all',
				'stylers': [
					{
						'color': '#46bcec'
					},
					{
						'visibility': 'on'
					}
				]
			},
			{
				'featureType': 'water',
				'elementType': 'geometry.fill',
				'stylers': [
					{
						'color': '#f8f8f8'
					}
				]
			},
			{
				'featureType': 'water',
				'elementType': 'labels.text.fill',
				'stylers': [
					{
						'color': '#070707'
					}
				]
			},
		]
	};
}


// WEBPACK FOOTER //
// ./src/helpers/index.tsx